import classnames from 'classnames';
import { FaPaw } from 'react-icons/fa';

import styles from './styles.module.scss';

export type LoadingProps = {
  mini?: boolean;
  color?: 'neutral' | 'primary';
};

function LoadingComponent({ mini = false, color = 'primary' }: LoadingProps) {
  if (mini) {
    return (
      <div
        className={classnames(styles.loadingContentMini, {
          [styles[color]]: color
        })}
      />
    );
  }

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingContent} />
      <FaPaw className={styles.loadingIcon} />
    </div>
  );
}

export default LoadingComponent;
